export default {"src":"/_next/static/media/logo-white.ed160a09.svg","height":673,"width":3111,"blurWidth":0,"blurHeight":0};